<template lang="pug">
  .auto-renew-container(v-if="show", @touchmove.prevent)
    .auto-block
      .auto-close(@click="close")
        img.close(src="https://m.hellobike.com/resource/helloyun/08345/Pe7OEngKfX.png?x-oss-process=image/quality,q_80")
      .auto-word 关闭连续包月后，下次不享优惠
      .auto-middle
        .auto-left
          .auto-left-line-one 单月买
          .auto-left-line-two
            .one-mouth-unit ¥
            .one-mouth-money {{price}}
        .auto-vs vs
        .auto-right
          .auto-right-line-one 连续包月
          .auto-right-line-two
            .one-mouth-unit ¥
            .one-mouth-money {{nextRenewalAmount}}
          .auto-right-line-three 优惠{{amountSaved}}元
      .auto-btn
        .auto-btn-right(@click="close") 享受当前优惠
          .more-choose 95%用户选择
        .auto-btn-left(@click="cancelSign") 放弃优惠
    .shadow
    </template>
<script>
import {
  cancelSignIn, getRedirectUrl,
} from '@/api/vip';
import {
  getTokenAndKey,
} from '@/utils';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { getVersion } from '@/utils/systemCode';
import Loading from '@/components/loading';
import config from '@/const/config';
import { ParamsUtil } from '../../../../utils/params';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: 0,
    },
    nextRenewalAmount: {
      type: Number,
      default: 0,
    },
    amountSaved: {
      type: Number,
      default: 0,
    },
    cancelSignDelay: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      env,
      version: '',
      isNew: null,
    };
  },
  watch: {
  },
  async created() {
    this.version = await getVersion();
    const { isNew } = this.$route.query;
    this.isNew = isNew;
  },
  mounted() {
    // this.$router.replace('/vip/v2?isRenew=true');
  },
  destroyed() {
  },
  methods: {
    async cancelSign() {
      Loading.show('加载中');
      UBT.clickButton({
        pageId: 'platform_guanlixufei_page',
        buttonName: 'platform_zhijieguanbi',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndKey();


      try {
        const res = await cancelSignIn({
          token,
          appCode: 'platform',
        });
        if (res.data) {
          Loading.close();

          setTimeout(() => {
            this.$emit('refresh');
          }, this.cancelSignDelay);

          this.$emit('update:show', false);
        } else {
          Loading.close();
        }
        // eslint-disable-next-line no-empty
      } catch {
        Loading.close();
      }
    },
    close() {
      UBT.clickButton({
        pageId: 'platform_guanlixufei_page',
        buttonName: 'platform_jixuxiangyong',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('close');
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.auto-renew-container {
  .auto-block {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 330;
    width: 3.2rem;
    height: 3rem;
    background: linear-gradient(180deg, #fff0d1 0%, #fff 25%, #fff 100%);
    border-radius: 0.12rem;

    .auto-close {
      position: absolute;
      right: 0.13rem;
      top: 0.13rem;

      img.close {
        width: 0.14rem;
        height: 0.14rem;
      }
    }

    .auto-word {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.18rem;
      color: #242729;
      text-align: center;
      padding-top: 0.3rem;
    }

    .auto-middle {
      display: flex;
      justify-content: center;
      margin-top: 0.14rem;

      .auto-left {
        width: 1.3rem;
        height: 0.86rem;
        background: #fff3db;
        border-radius: 0.08rem;
        padding-top: 0.11rem;
        margin-top: 0.08rem;

        .auto-left-line-one {
          font-family: PingFang SC, sans-serif;
          font-size: 0.16rem;
          font-weight: 500;
          line-height: 0.224rem;
          text-align: center;
          color: #868481;
        }

        .auto-left-line-two {
          margin-top: 0.03rem;
          display: flex;
          justify-content: center;
          color: #868481;

          .one-mouth-unit {
            font-family: DIN, sans-serif;
            font-size: 0.16rem;
            font-weight: 700;
            line-height: 0.1954rem;
            text-align: center;
            margin-top: 0.07rem;
          }

          .one-mouth-money {
            font-family: DIN, sans-serif;
            font-size: 0.24rem;
            font-weight: 700;
            line-height: 0.293rem;
            text-align: center;
          }
        }
      }

      .auto-vs {
        width: 0.31rem;
        height: 0.31rem;
        background: #f60;
        color: #fff;
        font-family: DIN, sans-serif;
        font-size: 0.18rem;
        font-weight: 700;
        line-height: 0.28rem;
        text-align: center;
        border-radius: 50%;
        margin-top: 0.31rem;
        margin-left: -0.18rem;
        z-index: 2;
      }

      .auto-right {
        margin-left: -0.13rem;
        width: 1.42rem;
        height: 1.05rem;
        background: #ffe8b9;
        border-radius: 0.08rem;
        padding-top: 0.11rem;

        .auto-right-line-one {
          font-family: PingFang SC, sans-serif;
          font-size: 0.16rem;
          font-weight: 500;
          line-height: 0.224rem;
          text-align: center;
          color: #242729;
        }

        .auto-right-line-two {
          margin-top: 0.03rem;
          display: flex;
          justify-content: center;
          color: #242729;

          .one-mouth-unit {
            font-family: DIN, sans-serif;
            font-size: 0.16rem;
            font-weight: 700;
            line-height: 0.1954rem;
            text-align: center;
            margin-top: 0.07rem;
          }

          .one-mouth-money {
            font-family: DIN, sans-serif;
            font-size: 0.24rem;
            font-weight: 700;
            line-height: 0.293rem;
            text-align: center;
          }
        }

        .auto-right-line-three {
          margin-top: 0.08rem;
          font-family: PingFang SC, sans-serif;
          font-size: 0.16rem;
          font-weight: 500;
          line-height: 0.224rem;
          text-align: center;
          color: #ff5729;
        }
      }
    }

    .auto-btn {
      padding: 0 0.2rem;
      margin-top: 0.26rem;

      .auto-btn-left {
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.14rem;
        color: #5a6066;
        line-height: 0.196rem;
        text-align: center;
        margin-top: 0.16rem;
      }

      .auto-btn-right {
        width: 2.88rem;
        height: 0.4rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        border-radius: 0.08rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.18rem;
        color: #fff;
        line-height: 0.4rem;
        text-align: center;
        position: relative;

        .more-choose {
          position: absolute;
          top: -0.2rem;
          right: 0;
          width: 0.87rem;
          height: 0.34rem;
          background-image: url(https://m.hellobike.com/resource/gallery/61/u0Uz_Dvplo.png?x-oss-process=image/quality,q_80);
          background-size: 100% 100%;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #441d06;
          line-height: 0.26rem;
          text-align: center;
          border-radius: 0.08rem;
        }
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
